import type { FaireProductEntity } from "../../entity_types/product";

export const p_uswwmaczta: FaireProductEntity = {
  token: "p_uswwmaczta",
  type: "product",
  name: "Striped Hooded Knit Open Cardigan",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3061626e0acaec9160c886dbd8a8a33f8f3ee01fd1ab6b2ef7635f366de4ed30.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7ddcab4eaeee950d778ad0b5e669441a0106d2ac2a56593e33f0e1abdedb34f.jpeg",
    "https://cdn.faire.com/fastly/c106be3d781a51cc32897174e2d1382f78cc9df1ade35a276a1c2e7f59559663.jpeg",
    "https://cdn.faire.com/fastly/bdffbb52dd13b3f9dd3bb4208d96fa5aa2bbb6e48ea7d664f69258290c5ec78b.jpeg",
    "https://cdn.faire.com/fastly/b287a5c2469158946fc4ddb76af339e32075a23fceac183297754f384a279e6c.jpeg",
    "https://cdn.faire.com/fastly/19585fc213ab715223c2f3a46b45b93bcbf54aa4a56986a7e72786c6fb6abc01.jpeg",
    "https://cdn.faire.com/fastly/42c0c630719e74030b5f17d79c945e183b1f4ecb77c108332213da96e20d01da.jpeg",
    "https://cdn.faire.com/fastly/aa904a0a7478ac60cca1650bfba6d719248e16d77d0e2a4da55f102f919d4c82.jpeg",
    "https://cdn.faire.com/fastly/48b6076237dff29b350f74d1715edabd2a0c87d03ad1cb2c0035d67e13659555.jpeg",
    "https://cdn.faire.com/fastly/c670e5febccb9201896f6487a087fb1d219a7fe6a24b35e845b2697888432652.jpeg",
    "https://cdn.faire.com/fastly/fc4ca09a3ee11dc68747a5ba21060abe18716c15d56b449b926107f97bd63886.jpeg",
    "https://cdn.faire.com/fastly/ba2bb6505b54d86a699a9c86de20ee3d9f56582960bf7aae2836ed2a4b3171a4.jpeg",
    "https://cdn.faire.com/fastly/54d3a41195b35d0eff601b1a6e39bef74fc93e5ba302a082560712c4635f927d.jpeg",
    "https://cdn.faire.com/fastly/af966c05f148a25890d032f8e76e3e01ebaec4c1adb90b8e9659eafb60a74730.jpeg",
    "https://cdn.faire.com/fastly/25ec9dc0d7289148e2bd3e52af4f19cbb87f49d52d878c14acaeca46caeddc37.jpeg",
    "https://cdn.faire.com/fastly/caff6e985427a5af5951d2eed6e2fde480c4138a19c4d13c5c69b36fd1015347.jpeg",
    "https://cdn.faire.com/fastly/7c145dfbe4de825a40591cce2cac44718887016dd8b6c0b6e8cae411d46dd61c.jpeg",
  ],
  priceDollars: 50.5,
  description:
    "STAY COZY AND CHIC IN THIS VERSATILE HOODED CARDIGAN, FEATURING A CLASSIC STRIPED KNIT PATTERN AND A COMFORTABLE OPEN FRONT DESIGN FOR EASY LAYERING.\n\nIMPORTED, DESIGNED IN USA\n\nSOFT STRETCH KNIT AND ADJUSTABLE HOOD\n\nCLASSIC STRIPED PATTERN AND RELAXED FIT\n\nCONT 85% POLYESTER 10% VISCOSE 5% ELASTANE\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 101,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:41.413Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
